import { inlineMediaActions } from './actions-const';

export function inlineMediaError() {
  return {
    type: inlineMediaActions.INLINE_MEDIA_ERRORED,
  };
}

export function inlineMediaPlay(mediaUrl) {
  return {
    type: inlineMediaActions.INLINE_MEDIA_PLAYING,
    mediaUrl,
  };
}

export function inlineMediaPause() {
  return {
    type: inlineMediaActions.INLINE_MEDIA_PAUSED,
  };
}

export function inlineMediaStop() {
  return {
    type: inlineMediaActions.INLINE_MEDIA_STOPPED,
  };
}
